module.exports = __webpack_public_path__ + "static/media/builds.9d5fb373.png";